import React from "react";
import { Select } from "antd";
import { tPropertyBar } from "../../../assets/libs/i18n/translator";

const { Option } = Select;

export const CategorySelect = React.forwardRef(
    ({ categories = [], value, onChange }, ref) => (
        <Select
            ref={ref}
            value={value}
            onChange={onChange}
        >
            <Option value={0}>
                {tPropertyBar("selectCategory")}
            </Option>

            {categories.map((category) => (
                <Option key={category.key} value={category.key}>
                    {category.name}
                </Option>
            ))}
        </Select>
    )
);